<template>
  <div v-if="showGreetingCardExtra">
    <ProductGreetingCardExtra
      v-for="(greetingCardExtra, i) in greetingCardExtras"
      :key="i"
      :title="greetingCardExtra.title"
      :handle="greetingCardExtra.greetingCardHandle"
      :multiple-selection="
        greetingCardExtra?.tag
          ? greetingCardExtra?.tag?.split('-').at(-1) == 'multiple'
          : false
      "
      :dynamic-price="greetingCardExtra.dynamicPrice"
      @greeting-card-selected="getProductGrettingCardSelected"
    />
  </div>
</template>

<script lang="ts" setup>
import useProductStore from '@/store/product'
import useSettingStore from '@/store/setting'
import { onMounted, watch, computed, ref, defineAsyncComponent } from 'vue'
import { isProductHasTags } from '@/utils/product'
import {
  EVENT_UPDATE_GREETING_CARD_EXTRA,
  HANDLE_PRODUCT_UPSELL_WITH_GREETING_CARD,
} from '@/utils'
import EventBus from '@/services/eventbus'

const ProductGreetingCardExtra = defineAsyncComponent(
  () => import('./ProductGreetingCardExtra.vue')
)

const productStore = useProductStore()
const settingStore = useSettingStore()

const lineItemProductGreetingCardExtras = ref([])
const productGreetingCardExtras = ref([])

const greetingCardExtras = computed(() => {
  if (!settingStore.baseProductPage?.upsellGreetingCard?.length) {
    return false
  }
  const upsellGreetingCardItems =
    settingStore.baseProductPage?.upsellGreetingCard.filter((item) =>
      isProductHasTags(productStore.product, [item?.tag || ''])
    )
  return upsellGreetingCardItems
})

const showGreetingCardExtra = computed(() => {
  if (!greetingCardExtras.value?.length) return false

  const skuPrefix =
    settingStore.baseProductPage?.skuPrefixHideUpsellGreetingCard?.split(',') ||
    []
  const productSkuPrefix =
    productStore.selectedVariant?.skuPrefix?.toUpperCase()

  if (skuPrefix.includes(productSkuPrefix)) {
    EventBus.trigger(EVENT_UPDATE_GREETING_CARD_EXTRA, [])
    return false
  }

  return true
})

onMounted(() => {
  watch(
    () => productGreetingCardExtras.value,
    () => {
      lineItemProductGreetingCardExtras.value =
        productGreetingCardExtras.value.map((item) => ({
          merchandiseId: item.merchandiseId,
          quantity: item.quantity || 1,
          attributes: item.attributes,
        }))
      EventBus.trigger(
        EVENT_UPDATE_GREETING_CARD_EXTRA,
        lineItemProductGreetingCardExtras.value
      )
    },
    {
      deep: true,
    }
  )
})

function getProductGrettingCardSelected(data: any) {
  if (data?.multiple) {
    const productGreetingCardExtrasNoContainProductHandle = []
    if (productGreetingCardExtras.value?.length) {
      for (let i = 0; i < productGreetingCardExtras.value.length; i++) {
        if (
          productGreetingCardExtras.value[i].productHandle != data.productHandle
        ) {
          productGreetingCardExtrasNoContainProductHandle.push(
            productGreetingCardExtras.value[i]
          )
        }
      }
    }

    productGreetingCardExtras.value =
      productGreetingCardExtrasNoContainProductHandle

    let greetingCardVariantArrSelected = []
    if (data.greetingCardVariantArrSelected?.length) {
      for (let i = 0; i < data.greetingCardVariantArrSelected?.length; i++) {
        greetingCardVariantArrSelected.push({
          productHandle: data.productHandle,
          merchandiseId: data.greetingCardVariantArrSelected[i]?.id,
          quantity: data.quantity || 1,
          attributes: [
            {
              key: HANDLE_PRODUCT_UPSELL_WITH_GREETING_CARD,
              value: productStore.product?.handle,
            },
            {
              key: '_Pack 1',
              value: '3.99',
            },
            {
              key: '_Pack 2 - 25% OFF',
              value: '5.99',
            },
            {
              key: '_Pack 3 - 33% OFF',
              value: '7.99',
            },
            {
              key: '_Pack 5 - 50% OFF',
              value: '9.99',
            },
            {
              key: '_product-pack',
              value: 'true',
            },
          ],
        })
      }
    }

    productGreetingCardExtras.value.unshift(...greetingCardVariantArrSelected)
  } else {
    const index = productGreetingCardExtras.value.findIndex(
      (item) => item.productHandle == data.productHandle
    )
    if (index > -1) productGreetingCardExtras.value.splice(index, 1)

    if (data?.greetingCardVariantSelected) {
      productGreetingCardExtras.value.unshift({
        productHandle: data.productHandle,
        merchandiseId: data.greetingCardVariantSelected?.id,
        quantity: data.quantity || 1,
        attributes: [
          {
            key: HANDLE_PRODUCT_UPSELL_WITH_GREETING_CARD,
            value: productStore.product?.handle,
          },
        ],
      })
    }
  }
}
</script>
